module.exports = __webpack_public_path__ + "img/img_product_01_1@2x.0a3b81ba.png";